import store from '../../store'
import router from '../../router'
import userHelper from '@/utils/helper/userHelper'
import notification from 'ant-design-vue/es/notification'

function openPageWithPath(path, token) {
  if (!token) {
    token = store.getters.token
  }
  const encryptToken = userHelper.encryptToken(token)
  let tokenKey
  if (path.indexOf('?') >= 0) {
    tokenKey = '&token='
  } else {
    tokenKey = '?token='
  }
  const targetUrl = store.getters.platformConfig.backUrl + path + tokenKey + encryptToken
  window.open(targetUrl)
}

//云仓同行采购
function toPeerPurchase() {
  //token无需加密
  const url = store.getters.platformConfig.pcPurchaseUrl + '/login?token=' + store.getters.token
  window.open(url)
}

//跳转云仓
function toYunCang(type) {
  const userInfo = store.getters.userInfo
  const platformConfig = store.getters.platformConfig
  let url = ''
  const childAccountId = userInfo.account && userInfo.account > 3 ? userInfo.account : 0
  if (type == 0) {
    url = platformConfig.cloudUrl + '/?type=0&merchantOppId=' + userInfo.merchantId + '&platformId=' + platformConfig.platformId + '&childAccountId=' + childAccountId
  } else if (type == 1) {
    url = platformConfig.cloudUrl + '/warehouse/center/?type=200&menustype=0&merchantOppId=' + userInfo.merchantId + '&platformId=' + platformConfig.platformId + '&childAccountId=' + childAccountId
  }
  window.open(url)
}

//去平直采
function toMarketPurchaseList() {
  const path = '/#/marketPurchaseList?type=0'
  openPageWithPath(path)
}

//跳转外部路由数据
const skipList = [
  { name: 'SupplyChain', skip: () => toSupplyChain() },
  { name: 'YunCang', skip: () => toYunCang(0) },
  { name: 'CloudOrders', skip: () => toYunCang(1) }
]

//  版本路由控制
function verifyRouteIsGo(list, name) {
  if (list && list.length > 0) {
    let routeName = list.find((item, index, arr) => item === name)
    if (routeName) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

function goAuthentication() {
  router.push({
    name: 'BasicSettings'
  })
}

/**
 * 获取当前页面的地址（不含端口）
 * @returns {string} 如：http://localhost 或 https://www.example.com
 */
function getCurrentBaseUrl() {
  const { protocol, hostname } = window.location
  return `${protocol}//${hostname}`
}

//跳转AI旅链
const toSupplyChain = () => {
  const userInfo = store.getters.userInfo
  const { supplyChainUrl } = store.getters.appConfig
  const token = userInfo.token
  const url = `${supplyChainUrl}` + `/supplyChain/product/list?token=${token}`
  console.error('跳转AI旅链', url)
  window.open(url)
}

function goUpgradeOwn() {
  router.push({
    name: 'VersionDescription'
  })
}

//跳转老魔方辅助工具
export default class SkipOtherHelper {

  static getSkipItem(name) {
    return skipList.find((item, index, arr) => item.name === name)
  }

  static openPageWithPath(path) {
    openPageWithPath(path)
  }

  // 权限路由跳转
  static goPermissionRoute(name) {
    let versionInfo = store.getters.versionInfo
    // versionId==1 说明是无版本，则必须去认证页面
    // console.log('goPermissionRoute',versionInfo)
    if (versionInfo.versionLimit == 2) {
      return verifyRouteIsGo(versionInfo.versionRouteList, name)
    } else {
      return true
    }
  }

  static routeWarning() {
    let versionId = store.getters.versionInfo.versionId
    if (versionId == 1) {
      notification.warning({
        message: '提示',
        description: '需完成认证后，方可使用该功能！'
      })
      goAuthentication()
    } else {
      notification.warning({
        message: '提示',
        description: '您的版本已经过期，请续费或升级版本后操作！'
      })
      goUpgradeOwn()
    }
  }

}